// Do NOT add "use client" to this file
import { PAGE_TYPE } from "@faire/retailer-visitor-shared/consts/PAGE_TYPE";
import { DEPRECATED_backwardsCompatibleValues } from "@faire/retailer-visitor-shared/views/search-v2/util/DEPRECATED_backwardsCompatibleValues";
import { isNotUndefined, isTupleOfLength } from "@faire/web--source/common/typescriptUtils";
import { ProductVariationType } from "@faire/web-api--source/indigofair/data/ProductVariationType";
export var getAltTag = function(params, strictLocalize) {
    var productName = params.productName, pageType = params.pageType, title = params.title, brandName = params.brandName;
    switch(pageType){
        case PAGE_TYPE.CATEGORY:
            return strictLocalize({
                id: "thY7gP",
                defaultMessage: [
                    {
                        type: 1,
                        value: "productName"
                    },
                    {
                        type: 0,
                        value: " in "
                    },
                    {
                        type: 1,
                        value: "title"
                    }
                ]
            }, DEPRECATED_backwardsCompatibleValues({
                productName: productName,
                title: title
            }));
        case PAGE_TYPE.DISCOVER:
            return strictLocalize({
                id: "dbje4C",
                defaultMessage: [
                    {
                        type: 1,
                        value: "productName"
                    },
                    {
                        type: 0,
                        value: " and other "
                    },
                    {
                        type: 1,
                        value: "title"
                    },
                    {
                        type: 0,
                        value: " trending on Faire."
                    }
                ]
            }, DEPRECATED_backwardsCompatibleValues({
                productName: productName,
                title: title
            }));
        case PAGE_TYPE.BRAND:
            return strictLocalize({
                id: "Z6Fwve",
                defaultMessage: [
                    {
                        type: 1,
                        value: "productName"
                    },
                    {
                        type: 0,
                        value: " for wholesale by "
                    },
                    {
                        type: 1,
                        value: "brandName"
                    }
                ]
            }, DEPRECATED_backwardsCompatibleValues({
                productName: productName,
                brandName: brandName
            }));
        default:
            return undefined;
    }
};
export var getAltTagProductPage = function(product, isEnglish, brandName, strictLocalize) {
    var _product_purchase_information_variation_map_entries_find, _product_purchase_information_variation_map_entries, _product_purchase_information_variation_map, _product_purchase_information, _product_name, _product_name1, _product_details_taxonomy_type, _product_details;
    var colorEntryValues = (_product_purchase_information = product.purchase_information) === null || _product_purchase_information === void 0 ? void 0 : (_product_purchase_information_variation_map = _product_purchase_information.variation_map) === null || _product_purchase_information_variation_map === void 0 ? void 0 : (_product_purchase_information_variation_map_entries = _product_purchase_information_variation_map.entries) === null || _product_purchase_information_variation_map_entries === void 0 ? void 0 : (_product_purchase_information_variation_map_entries_find = _product_purchase_information_variation_map_entries.find(function(entry) {
        return entry.type === ProductVariationType.COLOR;
    })) === null || _product_purchase_information_variation_map_entries_find === void 0 ? void 0 : _product_purchase_information_variation_map_entries_find.entry_values;
    if (isNotUndefined(colorEntryValues) && isTupleOfLength(colorEntryValues, 1)) {
        var _product_name2, _product_name3;
        var fixedColor = colorEntryValues[0].value;
        var _product_name_translated;
        var productName = (_product_name_translated = (_product_name2 = product.name) === null || _product_name2 === void 0 ? void 0 : _product_name2.translated) !== null && _product_name_translated !== void 0 ? _product_name_translated : (_product_name3 = product.name) === null || _product_name3 === void 0 ? void 0 : _product_name3.original;
        var altTag = "".concat(fixedColor, " ").concat(productName);
        /**
         * If page is in English, we will
         * remove all special characters and numbers from fixedColor
         * check if fixedColor is partially in product name
         * if yes, alt tag would just be product name
         * if no, alt tag would be fixedColor + product name
         *
         * When page is not in English,
         * alt tag is fixedColor + product name
         */ if (isEnglish && fixedColor && productName) {
            fixedColor = fixedColor.replace(/[^a-zA-Z ]/g, " ");
            var fixedColorSplited = fixedColor.split(/\s+/);
            altTag = "".concat(fixedColorSplited.join(" "), " ").concat(productName);
            var productNameSplited = productName === null || productName === void 0 ? void 0 : productName.toLowerCase().split(/\s+/);
            if (fixedColorSplited.some(function(word) {
                return productNameSplited.includes(word.toLowerCase());
            })) {
                altTag = productName;
            }
        }
        return strictLocalize({
            id: "eREek1",
            defaultMessage: [
                {
                    type: 1,
                    value: "product"
                },
                {
                    type: 0,
                    value: " for wholesale on Faire"
                }
            ]
        }, DEPRECATED_backwardsCompatibleValues({
            product: altTag
        }));
    }
    var _product_name_translated1;
    return strictLocalize({
        id: "LEgnXJ",
        defaultMessage: [
            {
                type: 1,
                value: "brandName"
            },
            {
                type: 0,
                value: " - Wholesale "
            },
            {
                type: 1,
                value: "taxonomyType"
            },
            {
                type: 0,
                value: " - "
            },
            {
                type: 1,
                value: "productName"
            }
        ]
    }, DEPRECATED_backwardsCompatibleValues({
        productName: (_product_name_translated1 = (_product_name = product.name) === null || _product_name === void 0 ? void 0 : _product_name.translated) !== null && _product_name_translated1 !== void 0 ? _product_name_translated1 : (_product_name1 = product.name) === null || _product_name1 === void 0 ? void 0 : _product_name1.original,
        brandName: brandName,
        taxonomyType: (_product_details = product.details) === null || _product_details === void 0 ? void 0 : (_product_details_taxonomy_type = _product_details.taxonomy_type) === null || _product_details_taxonomy_type === void 0 ? void 0 : _product_details_taxonomy_type.name
    }));
};
